import React from "react";
import {
    Box,
    Grid,
    Text,
    Button,
    SimpleGrid,
    Input,
    Select,
    Badge,
    Flex,
    useDisclosure,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
    FiEye,
    FiPlus,
    FiMinus,
    FiInfo,
    FiBell,
    FiSlash
} from "react-icons/fi";
import Navbar from "../../Navbar/Navbar";
import Sidebar from "../../Sidebar";
import CompleteProfileModal from "../CompleteProfileModal";

const StatCard = ({ title, value, bg }) => (
    <Flex
        bg="white"
        p={{ base: 5, md: 6 }}
        borderRadius="16px"
        direction="column"
        boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.05)"
        border="1px solid #f0f2f5"
        transition="all 0.23s ease"
        _hover={{ transform: "translateY(-4px)", boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)" }}
        overflow="hidden"
        position="relative"
    >
        <Box
            position="absolute"
            top="-10px"
            right="-10px"
            bg={bg}
            w="100px"
            h="100px"
            borderRadius="full"
            opacity={0.05}
        />
        <Text fontSize="xs" color="#8898aa" fontWeight="700" mb={1} textTransform="uppercase" letterSpacing="0.025em">
            {title}
        </Text>
        <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="800" color="#32325d">
            {value}
        </Text>
        <Box mt={2} w="30px" h="3px" bg={bg} borderRadius="full" />
    </Flex>
);

const MobileUnverifiedDetails = () => {
    const { id } = useParams();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const SIDEBAR_WIDTH = "240px";

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="#f8f9fd"
                minH="100vh"
                mt="80px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* Header */}
                <Flex
                    direction={{ base: "column", md: "row" }}
                    justify="space-between"
                    align={{ base: "flex-start", md: "center" }}
                    mb={8}
                    gap={4}
                >
                    <Box>
                        <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="800" color="#32325d">
                            Mobile Unverified Detail
                        </Text>
                        <Text fontSize="sm" color="#8898aa" fontWeight="500">
                            Manage information for <Text as="span" color="#5e72e4" fontWeight="700">Yader Reyes guzman</Text>
                        </Text>
                    </Box>
                    <Button
                        bg="#5e72e4"
                        color="white"
                        leftIcon={<FiEye />}
                        _hover={{ bg: "#4e62d4", transform: "translateY(-1px)", boxShadow: "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)" }}
                        onClick={onOpen}
                        width={{ base: "100%", md: "auto" }}
                        height="45px"
                        px={8}
                        borderRadius="10px"
                        fontSize="sm"
                        fontWeight="700"
                        transition="all 0.15s ease"
                    >
                        Login as Bettor
                    </Button>
                </Flex>

                {/* Top Cards */}
                <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={6} mb={8}>
                    <StatCard title="Balance" value="₹0.00" bg="#5e72e4" />
                    <StatCard title="Total Deposits" value="₹0.00" bg="#2dce89" />
                    <StatCard title="Total Withdrawals" value="₹0.00" bg="#f5365c" />
                    <StatCard title="Transactions" value="0" bg="#11cdef" />
                    <StatCard title="Bets Placed" value="0" bg="#fb6340" />
                    <StatCard title="Returned Amount" value="₹0.00" bg="#32325d" />
                    <StatCard title="Referred" value="₹0.00" bg="#8965e0" />
                    <StatCard title="Ref. Commission" value="₹0.00" bg="#51cbce" />
                </SimpleGrid>

                {/* Action Buttons */}
                <Box bg="white" p={1} borderRadius="16px" boxShadow="sm" mb={8} border="1px solid #f0f2f5">
                    <SimpleGrid columns={{ base: 2, sm: 3, md: 5 }} spacing={2}>
                        <Button variant="ghost" colorScheme="whatsapp" leftIcon={<FiPlus />} borderRadius="12px" py={7}>Add Balance</Button>
                        <Button variant="ghost" colorScheme="red" leftIcon={<FiMinus />} borderRadius="12px" py={7}>Sub Balance</Button>
                        <Button variant="ghost" colorScheme="blue" leftIcon={<FiInfo />} borderRadius="12px" py={7}>Logins</Button>
                        <Button variant="ghost" colorScheme="purple" leftIcon={<FiBell />} borderRadius="12px" py={7}>Notifications</Button>
                        <Button variant="ghost" colorScheme="orange" leftIcon={<FiSlash />} borderRadius="12px" py={7}>Ban Bettor</Button>
                    </SimpleGrid>
                </Box>

                {/* Information Form */}
                <Box
                    bg="white"
                    p={{ base: 6, md: 10 }}
                    borderRadius="20px"
                    boxShadow="0 10px 30px rgba(0, 0, 0, 0.04)"
                    border="1px solid #f0f2f5"
                >
                    <Flex align="center" mb={8}>
                        <Box w="4px" h="24px" bg="#5e72e4" borderRadius="full" mr={3} />
                        <Text fontWeight="800" fontSize="lg" color="#32325d">
                            Personal Information
                        </Text>
                    </Flex>

                    <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={8}>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">First Name</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" defaultValue="Yader Reyes" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }} />
                        </Box>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">Last Name</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" defaultValue="guzman" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }} />
                        </Box>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">Email</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" isReadOnly value="[Email is Protected]" _focus={{ bg: "white" }} />
                        </Box>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">Mobile</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" placeholder="Mobile Number" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }} />
                        </Box>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">Address</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" placeholder="Address" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }} />
                        </Box>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">City</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" placeholder="City" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }} />
                        </Box>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">State</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" placeholder="State" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }} />
                        </Box>
                        <Box>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">Zip Code</Text>
                            <Input h="45px" borderRadius="10px" bg="#f8f9fd" border="none" placeholder="Zip / Postal" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }} />
                        </Box>
                        <Box gridColumn={{ base: "span 1", md: "span 2" }}>
                            <Text fontSize="xs" fontWeight="800" mb={2} color="#8898aa" textTransform="uppercase">Country</Text>
                            <Select h="45px" borderRadius="10px" bg="#f8f9fd" border="none" _focus={{ bg: "white", boxShadow: "0 0 0 2px #5e72e4" }}>
                                <option>Afghanistan</option>
                                <option>India</option>
                                <option>USA</option>
                            </Select>
                        </Box>
                    </Grid>

                    {/* Verification Badges */}
                    <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={4} mt={12}>
                        <Badge color="#2dce89" bg="rgba(45, 206, 137, 0.1)" py={3} borderRadius="10px" textAlign="center" fontSize="xs" fontWeight="800">
                            EMAIL VERIFIED
                        </Badge>
                        <Badge color="#f5365c" bg="rgba(245, 54, 92, 0.1)" py={3} borderRadius="10px" textAlign="center" fontSize="xs" fontWeight="800">
                            MOBILE UNVERIFIED
                        </Badge>
                        <Badge color="#f5365c" bg="rgba(245, 54, 92, 0.1)" py={3} borderRadius="10px" textAlign="center" fontSize="xs" fontWeight="800">
                            2FA DISABLED
                        </Badge>
                        <Badge color="#2dce89" bg="rgba(45, 206, 137, 0.1)" py={3} borderRadius="10px" textAlign="center" fontSize="xs" fontWeight="800">
                            KYC VERIFIED
                        </Badge>
                    </SimpleGrid>

                    <Button
                        mt={12}
                        bg="#5e72e4"
                        color="white"
                        _hover={{ bg: "#4e62d4", transform: "translateY(-1px)", boxShadow: "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)" }}
                        width="100%"
                        h="55px"
                        fontSize="16px"
                        fontWeight="800"
                        borderRadius="12px"
                        transition="all 0.15s ease"
                    >
                        Update Profile
                    </Button>
                </Box>
            </Box>

            <CompleteProfileModal isOpen={isOpen} onClose={onClose} />
        </>
    );
};

export default MobileUnverifiedDetails;
